var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconMarketplace(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 25.02 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "1Asset 5") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M3.5,9.43V13h18V9.35l.17.13c.34.22.67.45,1,.64.16.08.22.14.22.31,0,1.47,0,2.93,0,4.4q0,1.82,0,3.63A1.4,1.4,0,0,1,21.4,20H3.62a1.4,1.4,0,0,1-1.54-1.54c0-2.66,0-5.32,0-8,0-.22.08-.29.26-.38C2.74,9.91,3.11,9.67,3.5,9.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M24.67,4.84H.37l.14-.22c.78-1.11,1.55-2.23,2.34-3.33A9.22,9.22,0,0,1,3.57.42a1.34,1.34,0,0,1,1-.42H20.35A1.93,1.93,0,0,1,22,1L24.1,4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M12.54,5.14H24.37a.4.4,0,0,1,.43.25A1.87,1.87,0,0,1,25,6.3c0,.77,0,1.54,0,2.31A1.37,1.37,0,0,1,23.66,10a1.41,1.41,0,0,1-1.44-1.37c0-.24,0-.47,0-.71a1.37,1.37,0,0,0-2.73-.22,6.45,6.45,0,0,0,0,.91,1.39,1.39,0,0,1-2.79,0c0-.25,0-.49,0-.74a1.38,1.38,0,0,0-2.75-.06c0,.26,0,.52,0,.79a1.39,1.39,0,1,1-2.78,0c0-.24,0-.48,0-.71a1.38,1.38,0,0,0-2.76,0,6.46,6.46,0,0,1,0,1A1.37,1.37,0,0,1,6.79,10,1.38,1.38,0,0,1,5.57,8.62c0-.22,0-.44,0-.66A1.38,1.38,0,1,0,2.8,8a5.13,5.13,0,0,1,0,.93A1.4,1.4,0,0,1,1.21,10,1.38,1.38,0,0,1,0,8.63c0-.34,0-.67,0-1A6.59,6.59,0,0,1,.29,5.37a.27.27,0,0,1,.31-.24Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMarketplace);
export default __webpack_public_path__ + "static/media/icon-marketplace.e5564afd1e81ac889154a958cec729b4.svg";
export { ForwardRef as ReactComponent };